import { CoreReturnToMainMenuUIConfig } from '../cvp-webgames-core/Components/ui/react/core-return-to-main-menu-ui';
import VideoEnvironment from '../cvp-webgames-core/Components/Environments/React/VideoEnvironment';
import Tools from '../cvp-webgames-core/Misc/Tools';
import BaseScenario from '../cvp-webgames-core/Scenario/BaseScenario';
import { constants } from '../misc/constants';
import { GameDataConfig, SingleScenarioConfig } from '../cvp-webgames-core/Misc/interfaces';
import { SavingUIConfig } from '../components/ui/saving-ui';
import { setFocus, setUp508, PageType, updateLast508Window, CustomGameDataManager, CustomGameSingleScenario, updateMentorVideo, setVolumeState } from '../misc/tools';
import { WelcomePageUIConfig } from '../pages/Welcome';
import { IntroScreenUIConfig } from '../components/ui/intro-screen-ui';
import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from '../cvp-webgames-core/Components/ui/react/core-general-question-ui';
import { QuestionType1UIConfig } from '../components/ui/question-type1-ui';
import { ScenarioInfoUIConfig, SingleScenarioInfoConfig } from '../components/ui/scenario-info-ui';
import { SingleVideoSegmentItem } from '../cvp-webgames-core/VideoSegment/VideoSegmentItem';
import { PreCacheManager } from '../cvp-webgames-core/pre-caching/pre-cache-manager';
import { PreCacheItem, PrecacheItemType, SinglePreCacheItem } from '../cvp-webgames-core/pre-caching/pre-cache-item';
import { AlertUIConfig } from '../components/ui/alert-ui';
import { FeedbackUIConfig } from '../components/ui/feedback-ui';
import { SkipContentUIConfig } from '../components/ui/skip-content-ui';
import { GeneralAARUIConfig, GeneralAARUISingleEntryConfig } from '../cvp-webgames-core/Components/ui/react/core-general-aar-ui';
import { coreConstantsGeneralUIs } from '../cvp-webgames-core/Misc/CoreConstants';
import { HUDUIConfig } from '../components/hud/HUDUI';
import { OverlayImgConfig } from '../components/ui/overlay-img';
import { AiChatUIConfig } from '../components/ui/ai-chat';
import { BackdropProps } from '@mui/material';

// class TemplatePreCacheScenario extends PreCacheItem {
//     public get title(): string {
//         return 'Template Scenario';
//     }
//     public getItems(): SinglePreCacheItem[] {
//         return [
//         ];
//     }
// }
export enum GameScenarioWindow508Type {
    Main,
    ResumeUI,
    ReturnToMainMenuUI,
    SimpleAccessibility,
    QuestionType1UI,
    QuestionType2UI,
    MixedMediaUI,
    ScenarioInfoUI,
    RecapUI,
    AARUI,
    FeedbackUI,
    AlertUI,
    Sbar,
    Toolbag,
    AiCoach,
    IntroScreenUI
}
enum ReplayContentType {
    QuestionType1,
    QuestionType2,
}

interface ReplayContent {
    type: ReplayContentType;
    config: QuestionType1UIConfig;
}

let current508Window = GameScenarioWindow508Type.Main;
let windows508Layers: any[] = []

export enum ScoringType {
    bad = 0,
    good = 5,
}

export const getCompletionPercentage = (scenario: SingleScenarioConfig) => {
    return scenario.score / scenario.maxScore;
}

class GameBaseScenarioGeneralCaching extends PreCacheItem {
    public audioKeys = {
        feedback_not_all_correct: 'feedback_not_all_correct',
        feedback_almost_there: 'feedback_almost_there',
    };
    public getItems(): SinglePreCacheItem[] {
        return [
            // {
            //     type: PrecacheItemType.Audio,
            //     key: this.audioKeys.feedback_not_all_correct,
            //     src: process.env.PUBLIC_URL + '/assets/audio/scenario5/sc5-all/bs-scn-05-all-102.mp3'
            // }, {
            //     type: PrecacheItemType.Audio,
            //     key: this.audioKeys.feedback_not_all_correct,
            //     src: process.env.PUBLIC_URL + '/assets/audio/scenario5/sc5-all/bs-scn-05-all-100.mp3'
            // }
        ];
    }
}

export const gameBaseScenarioGeneralCaching = new GameBaseScenarioGeneralCaching();

const objectWindowIDs = {
    main: {
        objects: [
            'hud-logo-root',
            'vortex-first',
        ]
    },
    introScreenUI: {
        objects: [
            'IntroScreenUI-top',
            // 'IntroScreenUI-bottom',
        ]
    },
    resume: {
        objects: [
            'resume-content-top',
            'resume-content-bottom',
        ]
    },
    returnToMainMenu: {
        objects: [
            'return-to-main-menu-content-top',
            'return-to-main-menu-content-bottom',
        ]
    },
    simpleAccessibility: {
        objects: [
            'simple-accessibility-content-top',
            'simple-accessibility-content-bottom',
        ]
    },
    questionType1: {
        objects: [
            'question-type-1-content-top',
            // 'question-type-1-content-bottom',
        ]
    },
    questionType2: {
        objects: [
            'question-type-2-content-top',
            // 'question-type-2-content-bottom',
        ]
    },
    mixedMedia: {
        objects: [
            'mixed-media-content-top',
            // 'mixed-media-content-bottom',
        ]
    },
    scenarioInfo: {
        objects: [
            'scenario-info-content-top',
            // 'scenario-info-content-bottom',
        ]
    },
    recap: {
        objects: [
            'recap-content-top',
            // 'recap-content-bottom',
        ]
    },
    aar: {
        objects: [
            'aar-content-top',
            // 'aar-content-bottom',
        ]
    },
    feedback: {
        objects: [
            'feedback-content-top',
            // 'feedback-content-bottom',
        ]
    },
    alert: {
        objects: [
            'alert-content-top',
            'alert-content-bottom',
        ]
    },
    sbar: {
        objects: [
            'sbar-root',
            'sbar-close-bttn',
        ]
    },
    toolbag: {
        objects: [
            'toolbag-header',
            'toolbag-done-button',
        ]
    },
    aiCoach: {
        objects: [
            'ai-coach-top',
            'ai-coach-bottom',
        ]
    }
}

const setUpScenario508 = () => {
    windows508Layers[GameScenarioWindow508Type.Main] = {
        objects: objectWindowIDs.main.objects
    };
    windows508Layers[GameScenarioWindow508Type.IntroScreenUI] = {
        objects: objectWindowIDs.introScreenUI.objects
    };
    windows508Layers[GameScenarioWindow508Type.ResumeUI] = {
        objects: objectWindowIDs.resume.objects
    };
    windows508Layers[GameScenarioWindow508Type.ReturnToMainMenuUI] = {
        objects: objectWindowIDs.returnToMainMenu.objects
    };
    windows508Layers[GameScenarioWindow508Type.SimpleAccessibility] = {
        objects: objectWindowIDs.simpleAccessibility.objects
    };

    windows508Layers[GameScenarioWindow508Type.QuestionType1UI] = {
        objects: objectWindowIDs.questionType1.objects
    };
    windows508Layers[GameScenarioWindow508Type.QuestionType2UI] = {
        objects: objectWindowIDs.questionType2.objects
    };
    windows508Layers[GameScenarioWindow508Type.MixedMediaUI] = {
        objects: objectWindowIDs.mixedMedia.objects
    };
    windows508Layers[GameScenarioWindow508Type.ScenarioInfoUI] = {
        objects: objectWindowIDs.scenarioInfo.objects
    };
    windows508Layers[GameScenarioWindow508Type.RecapUI] = {
        objects: objectWindowIDs.recap.objects
    };
    windows508Layers[GameScenarioWindow508Type.AARUI] = {
        objects: objectWindowIDs.aar.objects
    };
    windows508Layers[GameScenarioWindow508Type.FeedbackUI] = {
        objects: objectWindowIDs.feedback.objects
    };
    windows508Layers[GameScenarioWindow508Type.AlertUI] = {
        objects: objectWindowIDs.alert.objects
    };
    windows508Layers[GameScenarioWindow508Type.Sbar] = {
        objects: objectWindowIDs.sbar.objects
    };
    windows508Layers[GameScenarioWindow508Type.Toolbag] = {
        objects: objectWindowIDs.toolbag.objects
    };
    windows508Layers[GameScenarioWindow508Type.AiCoach] = {
        objects: objectWindowIDs.aiCoach.objects
    };
}

const getCurrent508WindowLayer = () => {
    return windows508Layers[current508Window];
}

export const set508Window = (window: GameScenarioWindow508Type) => {
    current508Window = window;
    setFocus(getCurrent508WindowLayer().objects[0]);
}

setUpScenario508();
setUp508(() => getCurrent508WindowLayer())

//set508Window(Window508Type.Main);

export class GameBaseScenario extends BaseScenario {
    public uiWrapper = new UIWrapper(this);

    public correctScoreOverrideForQuestion3Part1 = 3;
    public correctScoreOverrideForQuestion3Part2 = 2;
    public hudId: string = undefined;
    public overlayImgId: string = undefined;
    public vortexId: string;
    public attempt_count = 0;
    private maxQuestionOptionCount = 0;
    public onUpdateScore = () => { }
	public get MentorTalkingVideo(): string {
        throw new Error('Needs to be implemented');
    }

    public get MentorVideoNullChapter(): string {
        return 'null-chapter'
    }
    // public score_first_attempt = 5;
    // public score_second_attempt = 3;

    public introScreenInfo(): IntroScreenUIConfig {
        throw new Error('introScreenInfo must be implemented');
    }

    public update508Window(window: GameScenarioWindow508Type) {
        set508Window(window);
    }

    public scenarioIndex(): number {
        throw new Error('scenarioIndex must be implemented');
    }

    public scenarioId(): PageType {
        throw new Error('scenarioId must be implemented');
    }

    public UpdateScoreFromCorrectAnswer(isCorrect: boolean, overrideCorrectScore?: number, overrideIncorrectScore?: number): Promise<boolean> {
        var correctScore = typeof overrideCorrectScore === 'undefined' ? ScoringType.good : overrideCorrectScore;
        var incorrectScore = typeof overrideIncorrectScore === 'undefined' ? ScoringType.bad : overrideIncorrectScore;

        return Tools.getSaveData().then((savedData: CustomGameDataManager) => {
            const scenario = savedData.data.scenarios[this.scenarioIndex()];
            scenario.score += (isCorrect ? correctScore : incorrectScore);
            // if(!isCorrect) {
            //     scenario.gaugeValue--;
            // }
            return Tools.saveGame(savedData);
        });

    }

    private getNextScenarioFromSaveData(savedData: GameDataConfig<CustomGameSingleScenario>) {
        var currScenario = savedData.scenarios[this.scenarioIndex()];
        var nextScenarioIndex = savedData.scenarios.indexOf(currScenario) + 1;
        return savedData.scenarios[nextScenarioIndex];
    }

    public replayContent(replayStep: () => void) {
        if (replayStep) {
            this.gameManager.SoundManager.stopAllSounds();
            this.uiWrapper.destroyAllUIInstances();
            Tools.forceRerenderUI(constants.uiNames.QuestionType1UI);
            this.blurFadeOut();

            replayStep();
        }
    }

    public playVideoChapter(partId: string, chapterId: string, onDone: () => void, loop?: boolean): void {
        let skipContentUIId = '';
        const context = this;

        const _onDone = () => {
            context.uiWrapper.destroyInstance(skipContentUIId);
            Tools.forceRerenderUI(constants.uiNames.SkipContentUI);
            (this.gameManager.environment as VideoEnvironment).pauseCurrentSequence();
            if (onDone) {
                onDone();
            }
        }
        if (chapterId === 'End Frame') {
            setTimeout(() => {
                _onDone()
            }, 100);
        }

        skipContentUIId = this.uiWrapper.displaySkipContentUI({
            onSkipContentClicked: _onDone
        });

        super.playVideoChapter(partId, chapterId, _onDone, loop);
    }

    public calculateIfScenarioPassed(): Promise<boolean> {
        var scenarioPassed = false;
        return Tools.getSaveData().then((savedData: CustomGameDataManager) => {
            var currentScenario = savedData.data.scenarios[this.scenarioIndex()];
            scenarioPassed = (currentScenario.score / currentScenario.maxScore) >= 0;

            return scenarioPassed;
        })
    }

    public endScenario(redirectUrl: string): Promise<boolean> {
        return this.calculateIfScenarioPassed().then((scenarioPassed: boolean) => {
            return Tools.getSaveData().then((savedData: CustomGameDataManager) => {
                var currentScenario = savedData.data.scenarios[this.scenarioIndex()];
                var nextScenario = this.getNextScenarioFromSaveData(savedData.data);
                savedData.data.lastVisitedScenarioIndx = -1;

                if (scenarioPassed === true) {
                    currentScenario.isCompleted = true;
                    if (nextScenario) {
                        nextScenario.isLocked = false;
                    }
                } else {
                    currentScenario.aarEntries = [];
                    currentScenario.area = -1;
                    currentScenario.score = 0;
                    // currentScenario.gaugeValue = currentScenario.gaugeMax;
                }
                return Tools.saveGame(savedData).then(() => {
                    super.endScenario(redirectUrl);
                    return true;
                });
            });
        })
    }

    public loadVideoFromUrl(url: string, onDone: () => void) {
        let obj: any = {
            partId: '',
            url: [url],
        };
        // this.loadAllVideosInEnvironment(obj, onReady);
        this.loadAllVideosInEnvironment(obj, () => onDone());
    }

    public getScenarioInfo(): SingleScenarioInfoConfig {
        throw new Error('getScenarioInfo must be implemented')
    }

    public getScenarioVideoURL(): string {
        throw new Error('getScenarioVideoURL must be implemented')
    }

    public resumeScenarioFromArea(areaIndx: number): void {
        throw new Error('resumeScenarioFromArea must be implemented')
    }



    public init(onDoneLoading: () => void): Promise<boolean> {
        (window as any)['set-508-window-return-to-main-menu-on'] = () => {
            set508Window(GameScenarioWindow508Type.ReturnToMainMenuUI);
        }
        (window as any)['set-508-window-return-to-main-menu-off'] = () => {
            updateLast508Window();
        }
        (window as any)['set-508-window-simple-accessibility-on'] = () => {
            set508Window(GameScenarioWindow508Type.SimpleAccessibility);
        }
        (window as any)['set-508-window-simple-accessibility-off'] = () => {
            updateLast508Window();
        }
        this.gameManager.customData.scenario = this;
        const context = this;
        var introData = this.introScreenInfo();
        return new Promise<boolean>((resolve) => {
            return Tools.getSaveData().then((savedData: CustomGameDataManager) => {
                var currentScenario: CustomGameSingleScenario = savedData.data.scenarios[this.scenarioIndex()];
                savedData.data.lastVisitedScenarioIndx = savedData.data.scenarios.indexOf(currentScenario);
                return Tools.saveGame(savedData).then(() => {
                    context.loadVideoFromUrl(context.getScenarioVideoURL(), () => {
                        // const videoSegmentManager = new PreCacheManager();
                        // const templatePrecacheInstance = new TemplatePreCacheScenario();
                        // videoSegmentManager.registerItem(templatePrecacheInstance);
                        context.uiWrapper.destroyAllUIInstances();
                        Tools.forceRerenderUI(coreConstantsGeneralUIs.CoreLoadingUI)
                        return context.shouldLoadScenario().then((shouldLoad: boolean) => {
                            if (shouldLoad) {
                                //every video currently gets played on the first part
                                const partId = 'Scenario Part 0';
                                context.playVideoChapter(partId, 'End Frame', () => {
                                }, false)

                                const onDone = () => {
                                    Tools.getSaveData(true).then((sData) => {
                                        context.resumeScenarioFromArea(currentScenario.area);
                                    })
                                }

                                onDone();
                            } else {
                                return Tools.getSaveData().then((newData1: CustomGameDataManager) => {
                                    context.start();
                                    resolve(true);
                                    onDoneLoading();
                                    Tools.getSaveData(true).then((sData) => {
                                        setVolumeState(sData.data.isAudioEnabled);
                                    })
                                })
                            }
                            
                        })

                    });
                })

            });
        })
    }

    public onQuestionType1Submitted(allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: any, correctNextStep: () => void, incorrectNextStep: (optionsToShow: GeneralQuestionUIConfigOption[]) => void, mentorUrl?: string) {
        if (parentQuestionConfig.multipleChoice) {
            this.onQuestionType1MultipleChoiceSubmitted(allOptions, selectedChoices, parentQuestionConfig, correctNextStep, incorrectNextStep, mentorUrl, selectedChoices[0].mentorFeedback, selectedChoices[0].mentorFeedback);
            return;
        }
        if (this.attempt_count === 0) {
            this.maxQuestionOptionCount = allOptions.length;
        }
        this.uiWrapper.displayFeedback({
            // audioUrl: selectedChoices[0].feedbackAudioUrl,
            onButtonClicked: () => {
                this.updateScoringAfterQuestionSubmission(selectedChoices[0].isCorrect, allOptions, selectedChoices, parentQuestionConfig, correctNextStep, correctNextStep/*incorrectNextStep*/);
            },
            subtitle: parentQuestionConfig.subtitle + '- Feedback',
            title: parentQuestionConfig.title,
            selectedOptions: selectedChoices,
            feedbackHtml: `
            
            <p class=" black-text">${selectedChoices[0].feedbackHtml}<p>

            `,
            talkVideoUrl: selectedChoices[0].mentorVid,
            talkVideoChapterId: selectedChoices[0].mentorFeedback
        })
    }

    private onQuestionType1MultipleChoiceSubmitted(allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: any, correctNextStep: () => void, incorrectNextStep: (optionsToShow: GeneralQuestionUIConfigOption[]) => void, mentorUrl?: string, mentorCorrectChapterId?: string[], mentorIncorrectChapterId?: string[]) {
        if (this.attempt_count === 0) {
            this.maxQuestionOptionCount = allOptions.length;
        }
        let feedbackTitle = '';
        let feedbackUrl = [''];
        const maxCorrectOptionsLength = (parentQuestionConfig.options as GeneralQuestionUIConfigOption[]).filter(o => o.isCorrect).length;
        const correctOptionsLength = selectedChoices.filter(o => o.isCorrect).length;
        const selectedOptionsLength = selectedChoices.length;
        const selectedWrongOptionsLength = selectedChoices.filter(o => !o.isCorrect).length;
        let isCorrect = false;
        if (selectedWrongOptionsLength >= 1) {
            feedbackTitle = 'Some of these options may not be ideal. There are more appropriate options that can be selected.'
            feedbackUrl = [gameBaseScenarioGeneralCaching.getItemByKey(gameBaseScenarioGeneralCaching.audioKeys.feedback_not_all_correct).src];
            isCorrect = false;
        } else if (selectedWrongOptionsLength === 1 && correctOptionsLength === 0) {
            feedbackTitle = selectedChoices[0].feedbackHtml;
            // feedbackUrl = selectedChoices[0].feedbackAudioUrl;
            isCorrect = false;
        } else if (selectedWrongOptionsLength === 0 && maxCorrectOptionsLength === selectedOptionsLength) {
            feedbackTitle = selectedChoices.map((choice: GeneralQuestionUIConfigOption, i: number) => {
                return choice.feedbackHtml;
            }).join('<br /> <br />');
            let s = selectedChoices.map((choice: GeneralQuestionUIConfigOption, i: number) => {
                //return choice.feedbackAudioUrl;
                return ''
            });
            let sFlat: string[] = [];
            for (var i = 0; i < s.length; i++) {
                for (var p = 0; p < s[i].length; p++) {
                    sFlat.push(s[i][p]);
                }
            }
            feedbackUrl = sFlat;
            isCorrect = true;
        } else {
            feedbackTitle = 'Almost, there are more appropriate options that can be selected.'
            feedbackUrl = [gameBaseScenarioGeneralCaching.getItemByKey(gameBaseScenarioGeneralCaching.audioKeys.feedback_not_all_correct).src];
            isCorrect = false;
        }
        this.uiWrapper.displayFeedback({
            //audioUrl: feedbackUrl,
            subtitle: parentQuestionConfig.subtitle + '- Feedback',
            onButtonClicked: () => {
                this.updateScoringAfterQuestionSubmission(isCorrect, allOptions, selectedChoices, parentQuestionConfig, correctNextStep, correctNextStep /*incorrectNextStep*/);
            },
            title: parentQuestionConfig.title,
            selectedOptions: selectedChoices,
            feedbackHtml: `
            
            <p class=" black-text">${feedbackTitle}<p>

            `,
            talkVideoUrl: mentorUrl,
            talkVideoChapterId: isCorrect ? mentorCorrectChapterId : mentorIncorrectChapterId
        })
    }

    private updateScoringAfterQuestionSubmission(isCorrect: boolean, allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig, correctNextStep: () => void, incorrectNextStep: (optionsToShow: GeneralQuestionUIConfigOption[]) => void) {
        //if(isCorrect) {
        this.onUpdateScore = () => {
            Tools.getSaveData().then((savedData: CustomGameDataManager) => {
                const scoreAwarded = selectedChoices.filter(a => a.isCorrect).length;
                savedData.data.scenarios[this.scenarioIndex()].aarEntries.push({
                    questionTitle: parentQuestionConfig.questionTitle,
                    selectedOptions: selectedChoices,
                    feedback: selectedChoices.map((s: GeneralQuestionUIConfigOption, indx: number) => {
                        return s.feedbackHtml
                    }).join('<br /> <br />'),
                    // feedback: `You successfully answered the question in ${this.attempt_count + 1} attempt(s)`, 
                    isCorrect: isCorrect,
                    scoreAwarded: scoreAwarded,
                    scorePossible: this.maxQuestionOptionCount
                });
                savedData.data.scenarios[this.scenarioIndex()].score += scoreAwarded;

                Tools.saveGame(savedData).then(() => {
                    setTimeout(() => {
                        this.attempt_count = 0;
                    }, 1500);
                })
            })
        };
        correctNextStep();
        // } else {
        //     this.attempt_count++;
        //     for(var indx = selectedChoices.length - 1; indx >= 0; indx--) {
        //         if(!selectedChoices[indx].isCorrect) {
        //             allOptions.splice(allOptions.findIndex(o => selectedChoices[indx].title === o.title), 1);
        //         }
        //     }
        //     incorrectNextStep(allOptions);
        // }
    }

    public shouldLoadScenario(): Promise<boolean> {
        return Tools.getSaveData().then((savedData: CustomGameDataManager) => {
            var currentScenario = savedData.data.scenarios[this.scenarioIndex()];
            return typeof currentScenario.area !== 'undefined' && currentScenario.area > -1;
        });

    }

    public setAreaForCurrentScenario(area: number, currentQuestionNumber: number): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            if (area < 0) {
                resolve(true);
                return;
            }

            return Tools.getSaveData().then((savedData: CustomGameDataManager) => {
                var currentScenario = savedData.data.scenarios[this.scenarioIndex()];
                currentScenario.area = area;
                currentScenario.CurrentQuestion = currentQuestionNumber;
                return Tools.saveGame(savedData).then(() => {
                    resolve(true);
                });
            });
        });
    }
}

export class UIWrapper {
    constructor(private _sceanrio: GameBaseScenario) {
    }

    public displaySkipContentUI(config: SkipContentUIConfig): string {
        let res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.SkipContentUI, config);
        Tools.forceRerenderUI(constants.uiNames.SkipContentUI);
        return res;
    }

    public displayHUD(config: HUDUIConfig, instanceId?: string): string {
        if (instanceId) {
            if (this._sceanrio.gameManager.UiManager.updateUIInstance(instanceId, config)) {
                Tools.forceRerenderUI(constants.uiNames.HUDUI, instanceId);
                return instanceId;
            }
        }

        (window as any).isDisplayingHud = true;

        if ((window as any).forceUpdateInternalCCComp) {
            (window as any).forceUpdateInternalCCComp();
        }

        if ((window as any).onForceCCButtonRerender) {
            (window as any).onForceCCButtonRerender();
        }

        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.HUDUI, config);
        Tools.forceRerenderUI(constants.uiNames.HUDUI);
        return res;
    }

    public displayAiChat(config: AiChatUIConfig): string {
        // set508Window(GameScenarioWindow508Type.Sbar);

        var oldCallback = config.onCloseClicked;
        var context = this;
        config.onCloseClicked = () => {
            context.destroyAllUIInstances();
            set508Window(GameScenarioWindow508Type.AARUI);
            Tools.forceRerenderUI(constants.uiNames.AiChatUI);
            if (oldCallback) {
                oldCallback();
            }
        };
        var res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.AiChatUI, config);
        Tools.forceRerenderUI(constants.uiNames.AiChatUI);
        set508Window(GameScenarioWindow508Type.AiCoach);
        return res;
    }

    public displayAlert(config: AlertUIConfig): string {
        let context = this;
        let oldOkOnClicked = config.okButton.onClick;
        config.okButton.onClick = () => {
            context.destroyAllUIInstances();
            Tools.forceRerenderUI(constants.uiNames.AlertUI);
            set508Window(GameScenarioWindow508Type.Main);

            if (oldOkOnClicked) {
                oldOkOnClicked();
            }
        };
        let res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.AlertUI, config);
        Tools.forceRerenderUI(constants.uiNames.AlertUI);
        set508Window(GameScenarioWindow508Type.AlertUI);
        return res;
    }

    public displayAAR(redirectUrl: string): Promise<string> {
        let context = this;
        if (this._sceanrio.onUpdateScore) {
            this._sceanrio.onUpdateScore();
            this._sceanrio.onUpdateScore = null;
        }
        return Tools.getSaveData().then((savedData: CustomGameDataManager) => {
            const currentScenario = savedData.data.scenarios[this._sceanrio.scenarioIndex()];
            
            const config: GeneralAARUIConfig = {
                entries: currentScenario.aarEntries,
                hideScore: true,
                onGetIfPassed: () => {
                    return this._sceanrio.calculateIfScenarioPassed();
                },
                onCloseClicked: () => {
                    context.destroyAllUIInstances();
                    Tools.forceRerenderUI(coreConstantsGeneralUIs.CoreGeneralAAR);
                    if (this._sceanrio.scenarioIndex() === 4) {
                        this._sceanrio.endScenario(PageType.MainMenu);
                    } else {
                        this._sceanrio.endScenario(redirectUrl);
                        // this._sceanrio.endScenario("Scenario " + (this._sceanrio.scenarioIndex() + 2));
                    }
                    set508Window(GameScenarioWindow508Type.Main);
                },
                onAiCoachClicked: () => {
                    context.displayAiChat({});
                },
                hideAiCoach: true
            };
            let res = this._sceanrio.gameManager.UiManager.createUIInstance(coreConstantsGeneralUIs.CoreGeneralAAR, config);
            Tools.forceRerenderUI(coreConstantsGeneralUIs.CoreGeneralAAR);
            set508Window(GameScenarioWindow508Type.AARUI);
            return res;
        })

    }

    public displayScenarioInfoUI(config: ScenarioInfoUIConfig): string {
        let context = this;
        let oldOnReturnToMainMenuClicked = config.onReturnToMainMenuClicked;
        config.onReturnToMainMenuClicked = () => {
            context.destroyAllUIInstances();
            Tools.forceRerenderUI(constants.uiNames.ScenarioInfoUI);
            set508Window(GameScenarioWindow508Type.Main);

            if (oldOnReturnToMainMenuClicked) {
                oldOnReturnToMainMenuClicked();
            }
        };

        let oldOnStartScenarioClicked = config.onStartScenarioClicked;
        config.onStartScenarioClicked = (pageType: PageType) => {
            context.destroyAllUIInstances();
            Tools.forceRerenderUI(constants.uiNames.ScenarioInfoUI);
            set508Window(GameScenarioWindow508Type.Main);

            if (oldOnStartScenarioClicked) {
                oldOnStartScenarioClicked(pageType);
            }
        };
        let res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.ScenarioInfoUI, config);
        Tools.forceRerenderUI(constants.uiNames.ScenarioInfoUI);
        set508Window(GameScenarioWindow508Type.ScenarioInfoUI);
        return res;
    }

    public displayFeedback(config: FeedbackUIConfig): string {
        //updateMentorVideo(true, config.talkVideoUrl, config.talkVideoChapterId, null, 328);
        const playStringOfVideos = (indx: number) => {
            if(indx < config.talkVideoChapterId.length) {
                updateMentorVideo(false, config.talkVideoUrl, config.talkVideoChapterId[indx], () => {
                    playStringOfVideos(indx + 1);
                }, 328);
            }
        };

        playStringOfVideos(0);
        let context = this;
        let oldOnButtonClicked = config.onButtonClicked;
        config.onButtonClicked = () => {
            updateMentorVideo(false, config.talkVideoUrl, this._sceanrio.MentorVideoNullChapter);
            context.destroyAllUIInstances();
            Tools.forceRerenderUI(constants.uiNames.FeedbackUI);
            // Tools.forceRerenderUI(coreConstantsGeneralUIs.CoreGeneralFeedback);
            set508Window(GameScenarioWindow508Type.Main);

            if (oldOnButtonClicked) {
                oldOnButtonClicked();
            }
        };
        let res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.FeedbackUI, config);
        Tools.forceRerenderUI(constants.uiNames.FeedbackUI);
        // let res = this._sceanrio.gameManager.UiManager.createUIInstance(coreConstantsGeneralUIs.CoreGeneralFeedback, config);
        // Tools.forceRerenderUI(coreConstantsGeneralUIs.CoreGeneralFeedback);
        set508Window(GameScenarioWindow508Type.FeedbackUI);
        return res;
    }

    public displayQuestonType1UI(config: QuestionType1UIConfig, area: number, currentQuestionNumber: number, onReplayStep: () => void): Promise<string> {
        let context = this;
        this._sceanrio.setAreaForCurrentScenario(area, currentQuestionNumber);
        this._sceanrio.onUpdateScore();
        this._sceanrio.onUpdateScore = () => { };

        return Tools.getSaveData().then((savedData: CustomGameDataManager) => {
            // config.percentage = currentScenario.gaugeValue / currentScenario.gaugeMax;

            config.onReplayContentClicked = () => {
                set508Window(GameScenarioWindow508Type.Main);
                context._sceanrio.replayContent(() => onReplayStep());
            }

            let oldonSubmitClicked = config.onSubmitClicked;
            config.onSubmitClicked = (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
                context.destroyAllUIInstances();
                Tools.forceRerenderUI(constants.uiNames.QuestionType1UI);
                // Tools.forceRerenderUI(coreConstantsGeneralUIs.CoreGeneralQuestion);
                set508Window(GameScenarioWindow508Type.Main);

                if (oldonSubmitClicked) {
                    oldonSubmitClicked(allOptions, selectedChoices, parentQuestionConfig);
                }
            };
            this._sceanrio.blurFadeIn();
            // config.multipleChoice = true;
            // let res = this._sceanrio.gameManager.UiManager.createUIInstance(coreConstantsGeneralUIs.CoreGeneralQuestion, config);
            // Tools.forceRerenderUI(coreConstantsGeneralUIs.CoreGeneralQuestion);
            let res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.QuestionType1UI, config);
            Tools.forceRerenderUI(constants.uiNames.QuestionType1UI);
            set508Window(GameScenarioWindow508Type.QuestionType1UI);
            return res;
        });
    }

    // public displayQuestonType2UI(config: QuestionType2UIConfig, area: number): Promise<string> {
    //     let context = this;
    //     this._sceanrio.setAreaForCurrentScenario(area);

    //     return Tools.getSaveData().then((savedData: CustomGameDataManager) => {
    //         const currentScenario = this._sceanrio.getCurrentScenarioFromSaveData(savedData.data);
    //         // config.percentage = currentScenario.gaugeValue / currentScenario.gaugeMax;

    //         config.onReplayContentClicked = () => {
    //             set508Window(GameScenarioWindow508Type.Main);
    //             context._sceanrio.replayContent({
    //                 type: ReplayContentType.QuestionType2,
    //                 config: config
    //             });
    //         }

    //         let oldonSubmitClicked = config.onSubmitClicked;
    //         config.onSubmitClicked = (isCorrect: boolean, feedback: string, selectedTitle: string, parentQuestion: QuestionType2UIConfig) => {
    //             context.destroyAllUIInstances();
    //             Tools.forceRerenderUI(constants.uiNames.QuestionType2UI);
    //             // Tools.forceRerenderUI(coreConstantsGeneralUIs.CoreGeneralQuestion);
    //             set508Window(GameScenarioWindow508Type.Main);

    //             if (oldonSubmitClicked) {
    //                 oldonSubmitClicked(isCorrect, feedback, selectedTitle, parentQuestion);
    //             }
    //         };
    //         this._sceanrio.blurFadeIn();
    //         // config.multipleChoice = true;
    //         // let res = this._sceanrio.gameManager.UiManager.createUIInstance(coreConstantsGeneralUIs.CoreGeneralQuestion, config);
    //         // Tools.forceRerenderUI(coreConstantsGeneralUIs.CoreGeneralQuestion);
    //         let res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.QuestionType2UI, config);
    //         Tools.forceRerenderUI(constants.uiNames.QuestionType2UI);
    //         set508Window(GameScenarioWindow508Type.QuestionType2UI);
    //         return res;
    //     });
    // }

    public displayOverlayImg(config: OverlayImgConfig): string {
        if (this._sceanrio.overlayImgId) {
            this._sceanrio.gameManager.UiManager.updateUIInstance(this._sceanrio.overlayImgId, config);
            Tools.forceRerenderUI(constants.uiNames.OverlayImgUI);
            return;
        }

        this._sceanrio.overlayImgId = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.OverlayImgUI, config);
        Tools.forceRerenderUI(constants.uiNames.OverlayImgUI);
        return this._sceanrio.overlayImgId;
    }

    public displayIntroScreenUI(config: IntroScreenUIConfig): string {
        let context = this;
        let OldOnStartScenarioClicked = config.onStartScenarioClicked;
        config.onStartScenarioClicked = () => {
            updateMentorVideo(false, this._sceanrio.MentorTalkingVideo, this._sceanrio.MentorVideoNullChapter);
            context.destroyAllUIInstances();
            Tools.forceRerenderUI(constants.uiNames.IntroScreenUI);

            if (OldOnStartScenarioClicked) {
                OldOnStartScenarioClicked();
            }
            set508Window(GameScenarioWindow508Type.Main);
        };

        if (config.onReplayContentClicked) {
            let OldReplayContentClicked = config.onReplayContentClicked;
            config.onReplayContentClicked = () => {
                updateMentorVideo(false, this._sceanrio.MentorTalkingVideo, this._sceanrio.MentorVideoNullChapter);
                context.destroyAllUIInstances();
                Tools.forceRerenderUI(constants.uiNames.IntroScreenUI);

                if (OldReplayContentClicked) {
                    OldReplayContentClicked();
                }
                set508Window(GameScenarioWindow508Type.Main);
            };
        }

        let res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.IntroScreenUI, config);
        Tools.forceRerenderUI(constants.uiNames.IntroScreenUI);
        set508Window(GameScenarioWindow508Type.IntroScreenUI)
        return res;
    }

    public displayReturnToMainMenu(config: CoreReturnToMainMenuUIConfig): string {
        let context = this;
        let oldGoToMainMenuClicked = config.onGoToMainMenuClicked;
        config.onGoToMainMenuClicked = () => {
            context.destroyAllUIInstances();
            Tools.forceRerenderUI(constants.uiNames.ReturnToMainMenuUI);

            if (oldGoToMainMenuClicked) {
                oldGoToMainMenuClicked();
            }
            set508Window(GameScenarioWindow508Type.Main);
        };

        let oldOnCancelClicked = config.onCancelClicked;
        config.onCancelClicked = () => {
            context.destroyAllUIInstances();
            Tools.forceRerenderUI(constants.uiNames.ReturnToMainMenuUI);

            if (oldOnCancelClicked) {
                oldOnCancelClicked();
            }
            set508Window(GameScenarioWindow508Type.Main);
        };
        let res = this._sceanrio.gameManager.UiManager.createUIInstance(constants.uiNames.ReturnToMainMenuUI, config);
        Tools.forceRerenderUI(constants.uiNames.ReturnToMainMenuUI);
        set508Window(GameScenarioWindow508Type.ReturnToMainMenuUI)
        return res;
    }

    public destroyAllUIInstances(absolutelyEverySingleUI?: boolean) {
        set508Window(GameScenarioWindow508Type.Main);
        this._sceanrio.gameManager.UiManager.destroyAllInstances(absolutelyEverySingleUI ? [] : [constants.uiTags.Hud]);
    }

    public destroyInstance(id: string) {
        set508Window(GameScenarioWindow508Type.Main);
        this._sceanrio.gameManager.UiManager.destroyUIInstanceById(id);
    }
}

export interface GeneralPartConfig {
    videoUrl: string;
}

export interface BaseGeneralConfig {
}